<template>
  <div class="messenger-view-content-header">
    <div class="messenger-view-content-header__title">
      <messenger-text-with-emoji
        v-if="title"
        :text="title"
        emoji-size="20px"
      />
      <slot
        v-else
        name="title"
      />
    </div>
    <div class="messenger-view-content-header__description">
      <messenger-text-with-emoji
        :text="description"
        emoji-size="14px"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import MessengerTextWithEmoji from '@widgets/messenger/components/MessengerTextWithEmoji.vue'

defineProps<{
  title?: string
  description: string
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';
@import '@/styles/mixins.scss';

.messenger-view-content-header {
  &__title {
    @include truncate(3);
    color: $emphasize;
    font-size: 20px;
    font-weight: $bold-font;
    line-height: 24px;
    margin-bottom: 8px;
    text-align: center;
  }

  &__description {
    @include truncate(3);
    color: $neutral;
    font-size: 14px;
    font-weight: $regular-font;
    line-height: 20px;
    text-align: center;
  }
}
</style>
